/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useServiceCardNewStyles = makeStyles(theme => ({
  card: {
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  cardDisabled: {
    cursor: 'default',
  },
  root: {
    position: 'relative',
    padding: '24px',
    width: '280px',
    height: '100%',
    minHeight: '140.74px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardTitle: {
    fontWeight: 500,
    textTransform: 'uppercase',
  },
  cardTitleDisabled: {
    color: theme.palette.graphicElements.main,
  },
}));
